import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as bugReportsActions from '../../redux/actions/bugReportsActions';
import { bodyScroll } from '../../utils/utils';

import helpPageSectionsData from '../features/dashboard/HelpPageSectionsData';
import HelpPageSections from '../features/dashboard/HelpPageSections';
import BugReporterModal from '../features/dashboard/BugReporterModal';

class HelpPage extends Component {
  constructor(props) {
    super(props);
    this.state = { showBugReporterModal: false };
  }

  toggleBugReporterModal = () => {
    bodyScroll.toggle();
    this.setState(prevState => ({ showBugReporterModal: !prevState.showBugReporterModal }));
  }

  render() {
    const { dispatchBugReportsActions, match } = this.props;
    const { showBugReporterModal } = this.state;

    return (
      <Fragment>
        <Helmet>
          <title>Help</title>
        </Helmet>
        <div className="page-header">
          <div className="row">
            <h1 className="page-header__heading">Help</h1>
          </div>
        </div>
        <div className="help row">
          <div className="help__sidebar">
            {helpPageSectionsData().map(section => (
              <div className="help__sidebar-link" key={section.slug}>
                <NavLink to={`/help/${section.slug}`}>
                  {section.title}
                </NavLink>
              </div>
            ))}
          </div>
          <HelpPageSections
            slug={match.params.slug}
            handleBugReportClick={this.toggleBugReporterModal}
          />
        </div>
        <BugReporterModal
          visible={showBugReporterModal}
          toggleBugReporterModal={this.toggleBugReporterModal}
          bugReportsActions={dispatchBugReportsActions}
        />
      </Fragment>
    );
  }
}


function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return { dispatchBugReportsActions: bindActionCreators(bugReportsActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HelpPage);



// WEBPACK FOOTER //
// ./src/components/pages/HelpPage.js